<template>
  <div class="h-full risk overflow-y-auto overflow-x-hidden pl-10px">
    <div>
      <div class="flex justify-start items-start mb-10px mt-10px">
        <img src="../../assets/images/titleIcon.png" alt />
        <span class="text-16px text-white ml-4px">实时人员统计</span>
      </div>
      <div class="flex items-center">
        <img class="w-50px mr-5px" src="../../assets/images/control/person.png" alt />
        <div v-loading="personLoading" class="flex items-center flex-1">
          <div
            class="text-14px mr-8px"
            v-for="(item, index) in personList"
            :key="index"
            :class="{ 'cursor-pointer': item.label !== '访客人员' }"
          >
            <div class="flex mb-5px">
              <img
                class="mr-5px w-12px h-13px object-contain"
                src="../../assets/images/control/ornament.png"
                alt
              />
              <div class="text-white">{{ item.label }}</div>
            </div>
            <div class="text-hex-7ffbef ml-15px truncate flex" :title="item.num">
              <div class="max-w-50px truncate">{{ item.num }}</div>
              <div v-if="item.num !== '-'">人</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-end my-10px">
        <img src="../../assets/images/control/line.png" alt />
      </div>
      <!-- <div class="flex items-center">
        <img class="w-50px mr-5px" src="../../assets/images/control/car.png" alt />
        <div v-loading="carLoading" class="flex items-center flex-1" @click="carVisible = true">
          <div
            class="text-14px mr-8px cursor-pointer"
            v-for="(item, index) in carList"
            :key="index"
            @click="openCarList(item.label === '内部车辆')"
          >
            <div class="flex mb-5px">
              <img
                class="mr-5px w-12px h-13px object-contain"
                src="../../assets/images/control/ornament.png"
                alt
              />
              <div class="text-white">{{ item.label }}</div>
            </div>
            <div class="text-hex-7ffbef ml-15px truncate flex" :title="item.num">
              <div class="max-w-50px truncate">{{ item.num }}</div>
              <div v-if="item.num !== '-'">辆</div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="mt-10px" v-loading="alarmLoading">
      <div class="flex justify-between h-32px items-center">
        <div class="flex justify-start items-center mb-10px leading-32px h-32px">
          <img src="../../assets/images/titleIcon.png" alt />
          <div class="text-16px text-white ml-4px">今日实时报警</div>
        </div>
        <div
          class="charge-bg h-32px px-10px text-white cursor-pointer text-14px !leading-32px"
          @click="openAlarmList"
        >
          {{ alarmingCount }}/{{ todayAlarmCount }}今日报警
        </div>
      </div>
      <div class="flex">
        <div class="w-100px h-100px pie-bg">
          <v-chart
            v-loading="chartLoading"
            :options="pieOption"
            autoresize
            class="w-full h-full"
          ></v-chart>
        </div>
        <div class="flex flex-wrap flex-1 justify-between">
          <div
            class="w-110px h-25px relative text-14px pl-5px py-5px alarm-bg"
            v-for="(item, index) in alarmTypeList"
            :key="index"
          >
            <div class="absolute w-2px left-0 top-0">
              <div class="w-full h-8px" :style="`backgroundColor: ${item.color}`"></div>
              <div
                class="w-0px h-0px border-t-2px border-r-2px"
                :style="`borderColor: ${item.color} transparent transparent transparent`"
              ></div>
            </div>
            <div class="flex">
              <div class="text-hex-c0fbfe mr-5px">{{ item.label }}</div>
              <div class="flex">
                <div class="text-white w-30px truncate" :title="item.data">{{ item.data }}</div>
                <div class="text-hex-59bfbc">次</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-10px h-[calc(100%-260px)]">
      <!-- tab切换 -->
      <div class="tab-bg h-50px flex text-14px items-center px-10px mb-10px">
        <div class="flex justify-between flex-1">
          <div
            class="text-hex-c0fafe cursor-pointer relative"
            v-for="(item, index) in dynamicList"
            :key="index"
            :class="{ 'text-hex-6eeae0': item.isChoosed }"
            @click="toggleTab(item.label)"
          >
            <div>{{ item.label }}</div>
            <div
              v-if="item.isChoosed"
              class="tab-isChoosed w-57px h-8px absolute -bottom-15px"
            ></div>
          </div>
        </div>
        <!-- <div
          class="charge-bg w-100px h-32px flex justify-center items-center text-white cursor-pointer"
        >
          需充电卡片1张
        </div>-->
      </div>
      <!-- 建筑动态 -->
      <div v-show="currentTab === 'BuildingDynamic'" class="h-[calc(100%-60px)]">
        <div class="h-full min-h-230px">
          <FloorPeopleTree
            v-loading="buildingDynamicLoading"
            class="mt-10px overflow-auto pr-12px"
            :treeData="buildingDynamicList"
            @nodeClick="nodeClick"
          >
            <template #btns="{ node }">
              <div class="flex items-center mr-15px cursor-pointer" @click="goLocation(node.data)">
                <div class="h-14px w-15px location-icon mr-5px"></div>
                <span>定位</span>
              </div>
              <div class="flex items-center mr-15px cursor-pointer" @click="goRoute(node.data)">
                <div class="h-14px w-15px route-icon mr-5px"></div>
                <span>路线</span>
              </div>
            </template>
          </FloorPeopleTree>
        </div>
      </div>
      <!-- 区域动态 -->
      <!-- <div v-show="currentTab === 'RiskArea'" class="h-[calc(100%-60px)]">
        <div class="mb-10px">
          <el-input
            placeholder="请输入关键字"
            v-model="areaKeyword"
            clearable
            @input="handleAreaInput"
          >
            <i
              class="el-input__icon el-icon-search cursor-pointer"
              slot="suffix"
              @click="findAreaList"
            ></i>
          </el-input>
        </div>
        <FloorPeopleTree
          v-loading="areaLoading"
          class="mt-10px overflow-auto pr-12px"
          :treeData="areaList"
          @nodeClick="nodeClick"
        >
          <template #btns="{ node }">
            <div class="flex items-center mr-15px cursor-pointer" @click="goLocation(node.data)">
              <div class="h-14px w-15px location-icon mr-5px"></div>
              <span>定位</span>
            </div>
            <div class="flex items-center mr-15px cursor-pointer" @click="goRoute(node.data)">
              <div class="h-14px w-15px route-icon mr-5px"></div>
              <span>路线</span>
            </div>
          </template>
        </FloorPeopleTree> -->
      <!-- <el-table
          :data="areaList"
          height="calc(100% - 46px)"
          class="!min-h-230px"
          @row-click="areaRowClick"
          :row-class-name="rowClass"
          v-loading="areaLoading"
        >
          <el-table-column label=" 区域" prop="area" width="150" show-overflow-tooltip>
            <div slot-scope="{ row }" class="flex items-center">
              <img
                src="../../assets/images/control/choosed_arrow.png"
                alt
                v-if="row.isChoosed"
                class="mr-5px h-10px"
              />
              <div class="max-w-115px truncate">{{ row.area }}</div>
            </div>
          </el-table-column>
          <el-table-column label="人数" prop="count" show-overflow-tooltip></el-table-column>
          <el-table-column label="车辆" prop="carCount" show-overflow-tooltip></el-table-column>
        </el-table> -->
      <!-- </div> -->
      <!-- 人员动态 -->
      <div v-show="currentTab === 'PersonnelList'" class="h-[calc(100%-60px)]">
        <div class="mb-10px flex items-center">
          <el-select v-model="searchStatus" popper-class="visualization-select-popper">
            <el-option label="在线" value="0"></el-option>
            <el-option label="离线" value="1"></el-option>
          </el-select>
          <el-input
            placeholder="请输入关键字"
            suffix-icon="el-icon-search"
            v-model.trim="personnelKeyword"
            @input="filterTreeData"
          ></el-input>
        </div>
        <div class="h-[calc(100%-46px)] min-h-230px">
          <cockpit-tree
            ref="treeRef"
            class="mt-10px overflow-auto pr-12px"
            v-loading="treeLoading"
            v-if="treeData.length"
            :treeLoading="treeLoading"
            :treeData="treeData"
            :customFilter="customFilter"
            :isExpandAll="true"
            @nodeClick="nodeClick"
          >
            <template #btns="{ node }">
              <div
                class="flex items-center mr-15px cursor-pointer"
                @click.stop="goLocation(node.data)"
                v-if="searchStatus === '0'"
              >
                <div class="h-14px w-15px location-icon mr-5px"></div>
                <span>定位</span>
              </div>
              <div class="flex items-center mr-15px cursor-pointer" @click="goRoute(node.data)">
                <div class="h-14px w-15px route-icon mr-5px"></div>
                <span>路线</span>
              </div>
            </template>
          </cockpit-tree>
        </div>
      </div>
      <!-- 访客动态 -->
      <div v-show="currentTab === 'visitor'" class="h-[calc(100%-60px)]">
        <el-table
          :data="allVisitorRecordsList"
          height="calc(100% - 38px)"
          class="!min-h-200px"
          :row-class-name="rowClass"
        >
          <el-table-column
            label="姓名"
            prop="name"
            width="78"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="入厂状态"
            prop="incomingStatuStr"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" width="148">
            <template slot-scope="scope">
              <div class="flex">
                <div
                  class="flex items-center mr-15px cursor-pointer"
                  @click.stop="goLocation(scope.row, 'visitor')"
                  v-if="scope.row.onLine"
                >
                  <div class="h-14px w-15px location-icon mr-5px"></div>
                  <span>定位</span>
                </div>
                <div
                  class="flex items-center mr-15px cursor-pointer"
                  @click="goRoute(scope.row)"
                  v-if="scope.row.isVisitorCard"
                >
                  <div class="h-14px w-15px route-icon mr-5px"></div>
                  <span>路线</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="mt-10px text-right"
          background
          small
          @size-change="searchVisitorList"
          @current-change="getVisitorRecordsList"
          :current-page.sync="visitorPage.pageNo"
          layout="prev, pager, next"
          :pager-count="5"
          :page-size.sync="visitorPage.pageSize"
          :total="visitorPage.total"
        >
        </el-pagination>
      </div>
    </div>
    <person-alarm-list
      v-if="alarmListVisible"
      :alarmListVisible.sync="alarmListVisible"
    ></person-alarm-list>
    <alarmCamera
      v-if="alarmCameraVisible"
      :alarmCameraVisible.sync="alarmCameraVisible"
      :alarmInfo="alarmInfo"
      :customProps="customProps"
      @loadAlarm="getNowAlarmList"
    />
    <!-- 人员列表（内部、外部） -->
    <person-list
      v-if="innerPersonVisible"
      :visible.sync="innerPersonVisible"
      personSource="inner"
    ></person-list>
    <person-list
      v-if="outsidePersonVisible"
      :visible.sync="outsidePersonVisible"
      personSource="outside"
    ></person-list>
    <!-- 车辆列表（内部、外部） -->
    <!-- <car-list v-if="innerCarVisible" :visible.sync="innerCarVisible" carSource="inner"></car-list>
    <car-list
      v-if="outsideCarVisible"
      :visible.sync="outsideCarVisible"
      carSource="outside"
    ></car-list> -->
  </div>
</template>

<script>
import dayjs from 'dayjs'
import {
  forEach,
  map,
  assign,
  isEmpty,
  throttle,
  includes,
  filter,
  isNil,
  find,
  cloneDeep,
  get,
  max,
} from 'lodash'
import {
  PersonnelApi,
  StandardAlarmRecordApi,
  StandardAlarmSettingApi,
} from '@wiz-api/personnel-position'
import { AreaApi } from '@wiz-api/area-management'
import { PersonnelLocationApi } from '@wiz-api/huizhou2'
import CockpitTree from '@/components/cockpit/CockpitTree'
import personnelList from '../../assets/js/componentMethods/personnelList'
import riskArea from '../../assets/js/componentMethods/riskArea'
import ScoketManager from '../../assets/js/componentMethods/scoketManager'
// 人员树菜单
const FloorPeopleTree = () => {
  return import('./components/FloorPeopleTree')
}

// 报警列表
const PersonAlarmList = () => {
  return import('./components/PersonAlarmList')
}

// 摄像头列表
const alarmCamera = () => {
  return import('./components/alarmCamera')
}

// 人员列表
const PersonList = () => {
  return import('./PersonList')
}

// 车辆列表
// const CarList = () => {
//   return import('./CarList')
// }
const alarmSettingApi = new StandardAlarmSettingApi()
const personnelApi = new PersonnelApi()
const areaApi = new AreaApi()
const standardAlarmRecordApi = new StandardAlarmRecordApi()
const personnelLocationApi = new PersonnelLocationApi()

export default {
  props: {
    cloudRender: {
      type: Object,
      default: () => {},
    },
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    labelList: {
      type: Array,
      default: () => {
        return []
      },
    },
    onlineTagList: {
      type: Array,
      default: () => {
        return []
      },
    },
    allLineList: {
      type: Array,
      default: () => {
        return []
      },
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      todayAlarmCount: 0, // 今日报警总数
      alarmingCount: 0, // 报警中总数
      personLoading: false,
      carLoading: false,
      personList: [
        {
          label: '内部员工',
          num: '-',
        },
        {
          label: '外协人员',
          num: '-',
        },
        {
          label: '访客人员',
          num: '-',
        },
      ],
      // carList: [
      //   {
      //     label: '内部车辆',
      //     num: '-',
      //   },
      //   {
      //     label: '外部车辆',
      //     num: '-',
      //   },
      // ],
      chartLoading: false,
      pieOption: {
        backgroundColor: 'transparent',
        color: ['#6e66ac', '#e1775a', '#f3ad68', '#75f9ef', '#5bc572', '#fbe661', '#3a84f7'],
        title: {
          // eslint-disable-next-line no-useless-concat
          text: `${'{name|' + '报警总数' + '}\n{val|'}${0}}{unit|` + '次' + '}',
          top: 'center',
          left: 'center',
          textStyle: {
            rich: {
              name: {
                fontSize: 12,
                color: 'white',
                padding: [5, 0, 0, 0],
              },
              val: {
                fontSize: 15,
                color: 'white',
                fontWeight: 'bold',
                padding: [-5, 0, 0, 0],
              },
              unit: {
                fontSize: 12,
                color: 'white',
                padding: [-7, 0, 0, 0],
              },
            },
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['58%', '70%'],
            center: ['50%', '50%'],
            data: [],
            hoverAnimation: false,
            label: {
              show: false,
            },
          },
        ],
      },
      // tab
      dynamicList: [
        // 默认选中区域动态
        {
          label: '建筑动态',
          labelName: '建筑动态',
          value: 'BuildingDynamic',
          isChoosed: false,
        },
        // {
        //   label: '区域动态',
        //   labelName: '风险区域',
        //   value: 'RiskArea',
        //   isChoosed: true,
        // },
        {
          label: '人员动态',
          labelName: '人员',
          value: 'PersonnelList',
          isChoosed: true,
        },
        {
          label: '访客动态',
          labelName: '访客',
          value: 'visitor',
          isChoosed: false,
        },
      ],
      // 首次加载展示区域动态
      currentTab: 'PersonnelList',
      areaKeyword: '',
      visitorKeyword: '',
      personnelKeyword: '',
      searchStatus: '0',
      areaList: [],
      areaLoading: false,
      visitorPage: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      treeLoading: false,
      treeData: [],

      alarmListVisible: false,
      alarmLoading: false,
      alarmCameraVisible: false,
      alarmInfo: {},
      // 报警类型映射
      alarmTypeList: [
        {
          label: '非法进入',
          value: 'Entry',
          data: 0,
          color: '#6e66ac',
        },
        {
          label: '非法离开',
          value: 'Leave',
          data: 0,
          color: '#e1775a',
        },
        {
          label: '超员报警',
          value: 'Overcrowding',
          data: 0,
          color: '#f3ad68',
        },
        {
          label: '缺员报警',
          value: 'LackOfStaff',
          data: 0,
          color: '#75f9ef',
        },
        {
          label: '停留报警',
          value: 'Remain',
          data: 0,
          color: '#5bc572',
        },
        {
          label: '静止报警',
          value: 'Rest',
          data: 0,
          color: '#fbe661',
        },
        {
          label: 'SOS报警',
          value: 'SOS',
          data: 0,
          color: '#3a84f7',
        },
        {
          label: '跌落报警',
          value: 'Drop',
          data: 0,
          color: '#fa00ff',
        },
      ],
      allVisitorRecordsList: [],
      transferProps: {
        personnelId: '',
      },
      // 所有的人员列表
      allPerson: [],
      // clickAreaTimerOut: null,
      // 获取人员和车辆定时器
      personCarTimer: null,
      // 获取区域的定时器
      areaTimer: null,
      // 获取报警列表的定时器
      alarmTimer: null,
      // 是否正在查看历史轨迹
      isHistoricalTrajectory: false,
      // 内部人员列表弹框的显隐
      innerPersonVisible: false,
      // 外部人员列表弹框的显隐
      outsidePersonVisible: false,
      // // 内部车辆列表弹框的显隐
      // innerCarVisible: false,
      // // 外部车辆列表弹框的显隐
      // outsideCarVisible: false,
      // 是否正在创建历史轨迹
      isCreating: false,
      isCurrentId: '',
      // 建筑动态列表
      buildingDynamicList: [],
      buildingDynamicLoading: false,
      socketManager: null,
      socketLineList: [],
      throttledGetFloorPersonTotal: null,
      createdResult: null,
      // 记录已创建的报警marker
      alarmMarkers: new Map(), // key: tagId, value: { singleId, pictureId }
      // 记录上一次的未处理报警列表，用于对比检测已处理的报警
      previousUnhandledAlarmIds: new Set(),
    }
  },
  computed: {
    projectName() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
          ?.projectName || ''
      )
    },
  },
  components: {
    FloorPeopleTree,
    CockpitTree,
    PersonAlarmList,
    PersonList,
    alarmCamera,
    // CarList,
  },
  async created() {
    this.getUserStatistics()
    // this.getVehicleStatistics()
    this.getVisitorRecordsList()
    this.getAlarmTotal()
    this.getAlarmList()
    // this.findAreaList()
    this.getPersonnelList()
    this.getFloorPersonTotal()
    this.getNowAlarmList()
    // 十分钟刷新一次
    // this.personCarTimer = setInterval(() => {
    // }, 200000)
    // 20秒刷新一次访客
    this.areaTimer = setInterval(() => {
      this.getVisitorRecordsList()
      this.getAlarmTotal()
    }, 20000)
    // 7秒刷新一次
    this.alarmTimer = setInterval(() => {
      this.getUserStatistics()
      this.getNowAlarmList()
      this.getFloorPersonTotal()
      this.getPersonnelList()
    }, 7000)
    // 创建节流函数
    // this.throttledGetFloorPersonTotal = throttle(
    //   async () => {
    //     await this.getFloorPersonTotal()
    //   },
    //   7000,
    //   { trailing: true }
    // )
    // 初始化 socket 管理器
    // this.socketManager = new ScoketManager({
    //   onDataChange: ({ socketLineList, isFirstTime }) => {
    //     // 更新本地数据
    //     this.socketLineList = socketLineList
    //     // 根据条件决定是否立即执行或使用节流
    //     if (isFirstTime) {
    //       this.getFloorPersonTotal()
    //     } else {
    //       this.throttledGetFloorPersonTotal()
    //     }
    //   },
    // })
    // this.socketManager.connect(this.sourceId)
  },
  mounted() {
    // 监听是否查看历史轨迹事件
    window.addEventListener('HistoricalTrajectory', this.historicalTrajectoryHandler)
    window.addEventListener('loadHistoryTrialEnd', this.loadHistoryTrialEndHandler)
    window.addEventListener('loadHistoryTrial', this.loadHistoryTrialHandler)
    this.cloudRender.Dispatch.on('Marker', this.onAlarmMarkerClick)
  },
  methods: {
    onAlarmMarkerClick(evt) {
      if (!this.alarmCameraVisible) {
        const markerId = evt?.id
        if (!markerId) return
        // 仅处理报警 marker
        if (!markerId.startsWith('alarm_single_') && !markerId.startsWith('alarm_picture_')) return

        // 提取 tagId
        const tagId = markerId.replace('alarm_single_', '').replace('alarm_picture_', '')
        const record = this.alarmMarkers.get(tagId)
        if (!record) return

        // 位置优先使用事件里的实时坐标（若有），否则用记录的 onlinePerson 坐标
        const position = evt.pos || [
          record.onlinePerson.x,
          record.onlinePerson.y,
          record.onlinePerson.z - 4,
        ]

        // 回显报警信息 + 位置
        this.alarmInfo = {
          ...record.alarmItem,
          position,
        }
        this.alarmCameraVisible = true
      }
    },
    // 获取当日未处理报警列表
    async getNowAlarmList() {
      const [err, res] = await standardAlarmRecordApi.getList({
        startTime: dayjs()
          .startOf('date')
          .format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs()
          .endOf('date')
          .format('YYYY-MM-DD HH:mm:ss'),
        alarmRemoveType: 0,
        skipCount: 0,
        maxResultCount: 10000,
      })

      // 获取当前未处理的报警ID列表
      const currentUnhandledAlarmIds = new Set()

      if (!err && res && res.items.length > 0) {
        const alarmItems = filter(res.items, (it) => {
          const names = get(it, 'personNames')
          return names != null && String(names).trim() !== ''
        })

        // 遍历所有报警项
        alarmItems.forEach((alarmItem) => {
          if (alarmItem.tagCodeList && alarmItem.tagCodeList.length > 0) {
            const targetTagId = alarmItem.tagCodeList[0]
            // 记录当前未处理的报警ID
            currentUnhandledAlarmIds.add(targetTagId)

            // 查找对应的在线人员
            const onlinePerson = find(this.allLineList, ['tagId', targetTagId])

            if (onlinePerson) {
              if (!this.alarmCameraVisible) {
                const position = [onlinePerson.x, onlinePerson.y, onlinePerson.z]
                this.alarmInfo = {
                  ...alarmItem,
                  position,
                }
                this.alarmCameraVisible = true
              }
              // 如果该人员在线，检查坐标是否有变化再更新marker
              this.createOrUpdateAlarmMarker(targetTagId, onlinePerson, alarmItem)
            } else {
              // 如果该人员不在线，删除marker
              this.removeAlarmMarker(targetTagId)
            }
          }
        })
      }

      // 对比上一次和当前的报警列表，找出已处理的报警
      this.detectAndCleanupHandledAlarms(currentUnhandledAlarmIds)

      // 更新上一次的报警列表记录
      this.previousUnhandledAlarmIds = new Set(currentUnhandledAlarmIds)

      // 检查是否有需要删除的marker（人员已下线）
      this.cleanupOfflineMarkers()
    },
    // 创建或更新报警marker
    createOrUpdateAlarmMarker(tagId, onlinePerson, alarmItem) {
      const singleId = `alarm_single_${tagId}`
      const pictureId = `alarm_picture_${tagId}`

      // 计算位置 [x, y, z + 4]，严谨处理坐标值
      const pos = [onlinePerson.x || 0, onlinePerson.y || 0, (Number(onlinePerson.z) || 0) + 4]

      // 根据alarmType查找对应的label
      const alarmTypeItem = find(this.alarmTypeList, ['value', alarmItem.alarmType])
      const alarmTypeText = alarmTypeItem ? alarmTypeItem.label : '报警'

      const singleOption = {
        id: singleId,
        pos,
        background: 'alarmLocation',
        visible: true,
        text: alarmTypeText,
        textColor: '#ffff00ff',
        hasTriangle: false,
        nodeOffset: [-40, -120],
      }

      const pictureOption = {
        id: pictureId,
        pos,
        backgroundUrl: 'data://../apps/markers/alarmLocation/alarm_label.png',
        visible: true,
        imgSize: [50, 79],
        nodeOffset: [-25, -100],
      }
      if (this.alarmMarkers.has(tagId)) {
        // 检查坐标是否有变化，严谨处理坐标值
        const existingMarker = this.alarmMarkers.get(tagId)
        const existingPos = [
          existingMarker.onlinePerson.x || 0,
          existingMarker.onlinePerson.y || 0,
          (Number(existingMarker.onlinePerson.z) || 0) + 4,
        ]

        // 比较坐标是否发生变化
        const positionChanged =
          existingPos[0] !== pos[0] || existingPos[1] !== pos[1] || existingPos[2] !== pos[2]

        // 只有坐标变化或报警类型变化时才更新
        const alarmTypeChanged = existingMarker.alarmItem.alarmType !== alarmItem.alarmType

        if (positionChanged || alarmTypeChanged) {
          this.cloudRender.Marker.updateBySingleLine(singleOption)
          this.cloudRender.Marker.updateByPicture(pictureOption)
        }
      } else {
        // 不存在则创建
        this.cloudRender.Marker.createBySingleLine(singleOption)
        this.cloudRender.Marker.createByPicture(pictureOption)
      }
      // 同步缓存信息
      this.alarmMarkers.set(tagId, {
        singleId,
        pictureId,
        onlinePerson,
        alarmItem,
      })
    },
    // 删除报警marker
    removeAlarmMarker(tagId) {
      if (this.alarmMarkers.has(tagId)) {
        const marker = this.alarmMarkers.get(tagId)
        this.cloudRender.Marker.destroyMarker([marker.singleId, marker.pictureId])
        this.alarmMarkers.delete(tagId)
      }
    },
    // 检测并清理已处理的报警marker
    detectAndCleanupHandledAlarms(currentUnhandledAlarmIds) {
      // 找出上一次有但这一次没有的报警ID（即已处理的报警）
      const handledAlarmIds = new Set()
      this.previousUnhandledAlarmIds.forEach((tagId) => {
        if (!currentUnhandledAlarmIds.has(tagId)) {
          handledAlarmIds.add(tagId)
        }
      })

      // 清理已处理的报警marker
      handledAlarmIds.forEach((tagId) => {
        this.removeAlarmMarker(tagId)
      })
    },
    // 清理已下线人员的marker
    cleanupOfflineMarkers() {
      // 遍历已创建的marker，删除不在线人员的marker
      this.alarmMarkers.forEach((marker, tagId) => {
        if (!this.onlineTagList.includes(tagId)) {
          this.removeAlarmMarker(tagId)
        }
      })
    },
    // 销毁所有报警marker
    destroyAllAlarmMarkers() {
      const markerIds = []
      this.alarmMarkers.forEach((marker) => {
        markerIds.push(marker.singleId, marker.pictureId)
      })
      if (markerIds.length > 0) {
        this.cloudRender.Marker.destroyMarker(markerIds)
      }
      this.alarmMarkers.clear()
    },
    openVisitorDetail(data) {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: 'VisitorDetail',
            origin: 'tag',
            name: '访客详情',
            originTagName: 'VisitorDetail',
          },
          type: 'tags',
          props: {
            personnelId: data.id,
            tagCode: data.onLine.tagId,
            isTrajectory: false,
            online: data.onLine,
          },
        },
      })
      window.dispatchEvent(openEvent)
    },
    async nodeClick(data) {
      if (this.isHistoricalTrajectory) {
        return this.$message.warning({
          showClose: true,
          message: '请先退出轨迹回放',
        })
      }
      if (data.angleJson) {
        // this.checkLabel(this.currentTab === 'BuildingDynamic' ? 'BuildingList' : 'RiskArea')
        // 清空人员定位相关操作
        this.clearOperate()
        await this.cloudRender.Camera.moveCamera('CameraParam', JSON.parse(data.angleJson))
      }
      if (data.tagCode) {
        personnelList.openPersonnelDetail(data.id, data.tagCode, false)
      }
    },
    // 获取建筑的人数
    async getFloorPersonTotal(value) {
      this.buildingDynamicLoading = true
      const [err, res] = await personnelLocationApi.getFloorPersonCount({
        body: {
          modelId: this.sourceId,
          onLineList: this.allLineList,
        },
      })
      if (!err && res) {
        this.buildingDynamicList = this.dealFloorTree(res)
        this.buildingDynamicLoading = false
      }
    },
    // 获取人员统计
    async getUserStatistics() {
      this.personLoading = true
      const [err, res] = await personnelLocationApi.getUserStatistics_0({
        body: this.onlineTagList,
      })
      if (!err && res.code == 0 && res.data) {
        this.personList[0].num = res.data.inner
        this.personList[1].num = res.data.outside
        this.personList[2].num = res.data.visitor
      }
      this.personLoading = false
    },
    // 获取车辆统计
    // async getVehicleStatistics() {
    //   this.carLoading = true
    //   const [err, res] = await personnelLocationApi.getVehicleStatistics()
    //   if (!err && res.code == 0 && res.data) {
    //     this.carList[0].num = res.data.inner
    //     this.carList[1].num = res.data.outside
    //   }
    //   this.carLoading = false
    // },
    // 获取历史访客列表
    async getVisitorRecordsList() {
      const [err, res] = await personnelLocationApi.getVisitorPosition({
        body: {
          maxResultCount: this.visitorPage.pageSize,
          skipCount: (this.visitorPage.pageNo - 1) * this.visitorPage.pageSize,
          modelId: this.sourceId,
          onLineList: this.allLineList,
        },
      })
      if (!err && res) {
        const statusStrMap = {
          0: '未入厂',
          1: '已入厂',
          2: '已退场',
        }
        this.allVisitorRecordsList = res.items.map((item) => {
          return {
            ...item,
            incomingStatuStr: statusStrMap[item.incomingStatus],
          }
        })
        this.visitorPage.total = res.totalCount
      }
    },
    // 获取报警列表
    async getAlarmList() {
      this.alarmLoading = true
      const [err, res] = await standardAlarmRecordApi.getList({
        startTime: dayjs()
          .startOf('date')
          .format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs()
          .endOf('date')
          .format('YYYY-MM-DD HH:mm:ss'),
        skipCount: 0,
        maxResultCount: 10000,
      })
      if (!err && res) {
        this.pieOption.series[0].data = map(this.alarmTypeList, (item) => {
          return {
            name: item.label,
            value: filter(res.items, ['alarmType', item.value]).length,
          }
        })
        ;(this.pieOption.title.text =
          `${'{name|' + '报警总数' + '}\n{val|'}${res.totalCount}}{unit|` + '次' + '}'),
          forEach(this.alarmTypeList, (item) => {
            item.data = filter(res.items, ['alarmType', item.value]).length
          })
      }
      this.alarmLoading = false
    },
    // 获取报警总数
    async getAlarmTotal() {
      const [err, res] = await standardAlarmRecordApi.statisticalAlarmTotals()
      if (!err && res) {
        this.alarmingCount = res.toDayNotalarmCount
        this.todayAlarmCount = res.toDayalarmCount
      }
    },
    openAlarmList() {
      this.alarmListVisible = true
    },
    filterTreeData: throttle(function customFn() {
      this.$refs.treeRef?.treeRefFilter({
        personnelKeyword: this.personnelKeyword,
        searchStatus: this.searchStatus,
      })
    }, 500),
    // 自定义过滤
    customFilter(value, data) {
      return includes(data.name, value.personnelKeyword)
    },
    // 获取人员动态数据
    async getPersonnelList() {
      this.treeLoading = true
      const [err, res] = await personnelApi.getOrganizationTreeWithUserList({
        isBind: true,
      })
      if (!err && res) {
        this.allPerson = cloneDeep(res)
        this.treeData = get(this.dealUserTree(cloneDeep(res), this.searchStatus === '0'), '0')
        this.treeLoading = false
      }
    },
    // 区域树子节点数据调整
    dealAreaTree(areaTreeData) {
      return areaTreeData
        .map((item) => {
          if (item.positions) {
            item.positions.forEach((position) => {
              position.label = position.userName
              position.id = position.userId
              position.tagCode = position.tagId
              position.childen = []
            })
          }
          return {
            ...item,
            angleJson: item.playerVisualAngleJson,
            label: item.area,
            childen: item.positions,
            allPerson: item.positions ? item.positions.length : 0,
          }
        })
        .sort((a, b) => {
          // 根据 positions 长度排序，长度越大排越后
          const aLength = a.positions?.length || 0
          const bLength = b.positions?.length || 0
          return bLength - aLength
        })
    },
    // 楼层树子节点数据调整
    dealFloorTree(floorTreeData) {
      return floorTreeData
        .map((building) => {
          return {
            ...building,
            label: building.name,
            allPerson: building.floorPersonCounts?.reduce((sum, floor) => {
              return sum + (floor.onLineList?.length || 0)
            }, 0),
            childen: building.floorPersonCounts.map((floor) => {
              return {
                ...floor,
                label: floor.name,
                childen: floor.onLineList.map((person) => {
                  return {
                    ...person,
                    label: person.userName,
                    id: person.userId,
                    tagCode: person.tagId,
                    childen: [],
                  }
                }),
              }
            }),
          }
        })
        .sort((a, b) => {
          return b.allPerson - a.allPerson
        })
    },
    // 目录树子节点数据调整
    dealUserTree(userTreeData, isFilterOnline = true) {
      userTreeData = filter(userTreeData, (treeItem, index) => {
        const result = this.dealUserTree(treeItem.childen, isFilterOnline)
        treeItem.childen = result[0]
        treeItem.isExpand = result[1]
        treeItem.keyId = treeItem.organizationUnitId
        treeItem.name = treeItem.organizationUnitName
        if (treeItem.userList) {
          forEach(treeItem.userList, (userItem) => {
            userItem.keyId = treeItem.organizationUnitId + userItem.id
            userItem.organizationUnitId = treeItem.organizationUnitId
            userItem.organizationUnitName = treeItem.organizationUnitName
          })
          // 筛选出在线的人员
          if (isFilterOnline) {
            treeItem.userList = filter(treeItem.userList, (item) => {
              return find(this.onlineTagList, (it) => {
                return it === item.tagCode
              })
            })
          } else {
            // 筛选出离线的人员
            treeItem.userList = filter(treeItem.userList, (item) => {
              return !find(this.onlineTagList, (it) => {
                return it === item.tagCode
              })
            })
          }
          treeItem.childen.push(...treeItem.userList)
          if (treeItem.userList.length || treeItem.isExpand) {
            treeItem.isExpand = true
          }
        }
        return treeItem.userList.length || treeItem.isExpand
      })
      return [
        userTreeData,
        find(userTreeData, (item) => {
          return item.isExpand
        }),
      ]
    },
    // 切换tab栏
    toggleTab(currentLabel) {
      forEach(this.dynamicList, (item) => {
        if (item.label === currentLabel) {
          item.isChoosed = true
          this.currentTab = item.value
        } else {
          item.isChoosed = false
        }
      })
    },
    // 切换区域
    // toggleArea(id) {
    //   forEach(this.areaList, (item) => {
    //     if (item.id === id) {
    //       item.isChoosed = true
    //     } else {
    //       item.isChoosed = false
    //     }
    //   })
    // },
    // 人员动态定位
    goLocation(data, type) {
      // 如果正在查看历史轨迹，提示退出
      if (this.isHistoricalTrajectory) {
        this.$message.warning({
          showClose: true,
          message: '请先退出轨迹回放',
        })
        return
      }
      const label = find(this.labelList, ['code', 'PersonnelList'])
      if (!label.checked) {
        this.$message.warning({
          showClose: true,
          message: '没有勾选人员标签，请先勾选',
        })
        return
      }
      if (type === 'visitor') {
        this.openVisitorDetail(data)
      } else {
        personnelList.openPersonnelDetail(data.id, data.tagCode)
      }
    },
    // 人员动态路线
    goRoute(data) {
      if (this.isCurrentId === data.id) return
      if (this.isCreating) {
        return this.$message.warning({
          showClose: true,
          message: '上一个人员数据未加载完，请稍后',
        })
      }
      this.isCreating = true
      this.isCurrentId = data.id
      this.$emit('operateTrajectory', {
        visible: true,
        personnelId: data.id,
        tagCode: data.tagCode,
      })
    },
    // 获取区域动态列表
    async findAreaList() {
      // 第一次请求的时候有loading效果
      if (isNil(this.areaTimer)) this.areaLoading = true
      await personnelLocationApi.syncChronousPosition()
      const [err, res] = await personnelLocationApi.getArea({
        keyWord: this.areaKeyword,
        modelId: this.sourceId,
      })
      if (!err && res) {
        this.areaList = this.dealAreaTree(res)
      }
      this.areaLoading = false
    },
    // 搜索访客动态列表
    searchVisitorList() {
      this.visitorPage.pageNo = 1
      this.getVisitorRecordsList()
    },
    // 点击区域行
    // async areaRowClick(row) {
    //   // 如果正在查看历史轨迹，提示退出
    //   if (this.isHistoricalTrajectory) {
    //     return this.$message.warning({
    //       showClose: true,
    //       message: '请先退出轨迹回放',
    //     })
    //   }
    //   // 清空人员定位相关操作
    //   this.clearOperate()
    //   // 移动到区域视角
    //   this.moveToArea(row)
    //   // 切换选中
    //   this.toggleArea(row.id)
    // },
    // 点击定位到区域位置
    // async moveToArea(row) {
    //   if (this.clickAreaTimerOut) clearTimeout(this.clickAreaTimerOut)
    //   this.clickAreaTimerOut = setTimeout(async () => {
    //     this.checkLabel(this.currentTab)
    //     if (row && row.playerVisualAngleJson) {
    //       await this.cloudRender.Camera.moveCamera(
    //         'CameraParam',
    //         JSON.parse(row.playerVisualAngleJson)
    //       )
    //     } else if (row) {
    //       riskArea.moveToArea(row.id)
    //     }
    //   }, 500)
    // },
    // 获取table每一行的class
    rowClass({ row }) {
      if (row.isChoosed) {
        return 'table-choosed'
      }
      return ''
    },
    // 清空人员定位操作
    clearOperate() {
      // 取消跟随
      const cancelFollowEvent = new CustomEvent('cancelFollow')
      window.dispatchEvent(cancelFollowEvent)
    },
    // 检查对象标签是否打开，如果没打开就打开,（未确定原先需求为何存在，先保留若有需要再打开）
    // checkLabel(value) {
    //   if (value === 'RiskArea' && this.projectName === 'HZ') {
    //     value = 'RiskAreaHZ'
    //   }
    //   const label = find(this.labelList, ['code', value])
    //   const labelName = get(find(this.dynamicList, ['value', value]), 'labelName', '')
    //   if (!label) {
    //     return this.$message.warning({
    //       showClose: true,
    //       message: `没有配置${labelName}标签，请配置`,
    //     })
    //   }
    //   // 如果没有打开对应功能标签，则打开
    //   if (!label.checked) {
    //     const filterEvent = new CustomEvent('setLabelChecked', {
    //       detail: {
    //         code: value,
    //         checked: true,
    //       },
    //     })
    //     window.dispatchEvent(filterEvent)
    //   }
    // },
    // 输入搜索区域
    handleAreaInput() {
      _.throttle(this.findAreaList, 1000)()
    },
    // 监听是否查看历史轨迹
    historicalTrajectoryHandler(e) {
      this.isHistoricalTrajectory = e.detail?.isOpen
    },
    // 监听历史轨迹是否加载完成
    loadHistoryTrialEndHandler() {
      this.isCreating = false
    },
    // 监听历史轨迹是否加载完成
    loadHistoryTrialHandler() {
      this.isCreating = true
    },
    // 打开人员列表弹框
    openPersonList(item) {
      if (item.label === '访客人员') return
      this.innerPersonVisible = false
      this.outsidePersonVisible = false
      // this.innerCarVisible = false
      // this.outsideCarVisible = false
      if (item.label === '内部员工') {
        this.innerPersonVisible = true
      } else {
        this.outsidePersonVisible = true
      }
    },
    // 打开车辆列表弹框
    // openCarList(isInner) {
    //   this.innerPersonVisible = false
    //   this.outsidePersonVisible = false
    //   this.innerCarVisible = false
    //   this.outsideCarVisible = false
    //   if (isInner) {
    //     this.innerCarVisible = true
    //   } else {
    //     this.outsideCarVisible = true
    //   }
    // },
  },
  watch: {
    currentTab: {
      immediate: true,
      handler(value) {
        // 暂时访客不做处理
        if (value === 'visitor') return
        // 暂时建筑动态不做处理
        if (value === 'BuildingDynamic') return
        // this.checkLabel(value)
      },
    },
    searchStatus(value) {
      this.treeLoading = true
      this.treeData = get(this.dealUserTree(cloneDeep(this.allPerson), value === '0'), '0')
      this.$nextTick(() => {
        return (this.treeLoading = false)
      })
    },
    onlineTagList() {
      this.treeLoading = true
      if (this.searchStatus === '0') {
        this.treeData = get(this.dealUserTree(cloneDeep(this.allPerson), true), '0')
      }
      this.$nextTick(() => {
        this.treeLoading = false
      })
    },
  },
  beforeDestroy() {
    window.removeEventListener('HistoricalTrajectory', this.historicalTrajectoryHandler)
    window.removeEventListener('loadHistoryTrialEnd', this.loadHistoryTrialEndHandler)
    window.removeEventListener('loadHistoryTrial', this.loadHistoryTrialHandler)
    // if (this.personCarTimer) clearInterval(this.personCarTimer)
    if (this.areaTimer) clearInterval(this.areaTimer)
    if (this.alarmTimer) clearInterval(this.alarmTimer)
    if (this.createdResult) {
      this.cloudRender.PosViewer.destroyPosviewer(this.createdResult.data)
    }
    // 销毁所有报警marker
    this.destroyAllAlarmMarkers()
    // 销毁所有报警marker点击事件
    this.cloudRender.Dispatch.off('Marker', this.onAlarmMarkerClick)
    // 清理节流函数和连接
    // if (this.throttledGetFloorPersonTotal?.cancel) {
    //   this.throttledGetFloorPersonTotal.cancel()
    //   this.throttledGetFloorPersonTotal = null
    // }
    // this.socketManager.disconnect()
    // if (this.clickAreaTimerOut) clearTimeout(this.clickAreaTimerOut)
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/control.scss';
::v-deep .el-loading-mask {
  background-color: #0f393f;
}
.tab-bg {
  background: url('../../assets/images/control/tab.png');
  background-size: 100% 100%;
}

.charge-bg {
  background: url('../../assets/images/control/charge.png');
  background-size: 100% 100%;
}

.tab-isChoosed {
  background: url('../../assets/images/control/tab_choosed.png');
  background-size: 100% 100%;
}

.pie-bg {
  background: url('../../assets/images/control/pie_bg.png');
  background-size: 100% 100%;
}

.alarm-bg {
  background: url('../../assets/images/control/alarm_bg.png');
  background-size: 100% 100%;
}

.head-bg {
  background: url('../../assets/images/control/table_head.png');
  background-size: 100% 100%;
}

::v-deep .table-choosed {
  background: url('../../assets/images/control/table_choosed.png');
  background-size: 100% 100%;
  color: #93eaff;
}

.user-icon {
  background: url('../../assets/images/control/user.png');
  background-size: 100% 100%;
}

.location-icon {
  background: url('../../assets/images/control/location.png');
  background-size: 100% 100%;
}

.route-icon {
  background: url('../../assets/images/control/route.png');
  background-size: 100% 100%;
}

.area-box {
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 9px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #104a70;
    color: #104a70;
  }
}

.page-theme {
  ::v-deep {
    button[class^='btn-'] {
      width: 24px;
      height: 24px;
    }
    .btn-prev,
    .btn-next {
      background-color: #345479;
      color: #fff;
    }
    .el-pager {
      li {
        min-width: 24px !important;
        height: 24px;
        margin: 0 3px 0 3px !important;
        line-height: 24px;
        border-radius: 3px;
        border: 1px solid rgba(141, 194, 255, 0.28);
      }
    }
  }
}
</style>
